<template>
    <div class="min-h-screen">
        <PageHeader/>
        <main class="px-4 relative z-10 pt-8">
            <div class="container mx-auto">
                <slot />
            </div>
        </main>
    </div>
    <PageFooter/>
</template>

<script>

export default {
    name: "LayoutDefault",

}
</script>

<style scoped>

</style>
